module.exports = __webpack_public_path__ + "static/img/slogan.724d479.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/index1/slogan.png
// module id = xIJH
// module chunks = 7